export default __webpack_public_path__ + "static/media/Bird-Cake.0e1effd0.jpg";